/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["eo",[["atm","ptm"]],u,[["S","M","T","W","T","F","S"],["di","lu","ma","me","Äµa","ve","sa"],["dimanÄo","lundo","mardo","merkredo","ÄµaÅ­do","vendredo","sabato"],["di","lu","ma","me","Äµa","ve","sa"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","AÅ­g","Sep","Okt","Nov","Dec"],["Januaro","Februaro","Marto","Aprilo","Majo","Junio","Julio","AÅ­gusto","Septembro","Oktobro","Novembro","Decembro"]],u,[["a.n.e.","n.e."],u,["antaÅ­ nia erao","de nia erao"]],1,[6,0],["yy-MM-dd","y-MMM-dd","y-MMMM-dd","EEEE, 'la' d-'a' 'de' MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",","Â ",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","#,##0.00Â Â¤","#E0"],u,u,u,{"JPY":["JPÂ¥","Â¥"],"USD":["US$","$"]},"ltr", plural];
